module.exports = __webpack_public_path__ + "assets/img/step3.18fc2bd3.jpg";